/**
 * Returns a scroll helper that smoothly scrolls to any element by id.
 * Prevents the default anchor behaviour when used in onClick handlers.
 */
export function useScrollTo() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id.toLowerCase());
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const handleAnchorClick =
    (id: string) => (e: React.MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault();
      scrollTo(id);
    };

  return { scrollTo, handleAnchorClick };
}
